import { cx } from "@jugl-web/utils";
import { FC } from "react";
import { BUTTON_SIZE, CONTAINER_PADDING, VECTOR_THICKNESS } from "../../consts";
import { ReactComponent as VectorHorizIcon } from "./assets/vector-horiz.svg";
import { ReactComponent as VectorVertIcon } from "./assets/vector-vert.svg";

const VECTOR_CONTAINER_OFFSET =
  CONTAINER_PADDING + BUTTON_SIZE / 2 - VECTOR_THICKNESS / 2;

interface ButtonPositionIndicatorsProps {
  alignment: "left" | "right";
  bottomSpacing: number;
  sideSpacing: number;
}

export const ButtonPositionIndicators: FC<ButtonPositionIndicatorsProps> = ({
  alignment,
  bottomSpacing,
  sideSpacing,
}) => (
  <>
    <div
      className="absolute leading-[0]"
      style={{
        bottom: 4,
        right: alignment === "right" ? VECTOR_CONTAINER_OFFSET : undefined,
        left: alignment === "left" ? VECTOR_CONTAINER_OFFSET : undefined,
      }}
    >
      <VectorVertIcon />
      <div
        className={cx(
          "absolute top-1/2 -translate-y-1/2 rounded-2xl bg-white px-2 py-0.5 leading-[150%]",
          alignment === "right"
            ? "-left-2.5 -translate-x-full"
            : "-right-2.5 translate-x-full"
        )}
      >
        <span className="font-secondary text-sm text-dark">
          {bottomSpacing}px
        </span>
      </div>
    </div>
    <div
      className="absolute leading-[0]"
      style={{
        bottom: VECTOR_CONTAINER_OFFSET,
        right: alignment === "right" ? 4 : undefined,
        left: alignment === "left" ? 4 : undefined,
      }}
    >
      <VectorHorizIcon />
      <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 -translate-y-full rounded-2xl bg-white px-2 py-0.5 leading-[150%]">
        <span className="font-secondary text-sm text-dark">
          {sideSpacing}px
        </span>
      </div>
    </div>
  </>
);
